import { createContext } from "react";
import { BillingTier } from "../../__generated__/gql/graphql";
import defaultUserContext from "./default-user-context";

export interface UserContextType {
  isReady: boolean;
  isError: boolean;
  user?: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    identityId?: string | null;
    email?: string | null;
    intercomHash?: string | null;
  };
  billingInfo: {
    credits: number;
    creditsUsed: number;
    keywordQueryCredits: number;
    keywordQueriesPerMonth: number;
    keywordQueryCreditPrice: number;
    freeCreditsIssued: number;
    billingTier: BillingTier;
    articlesPerMonth: number;
    downgradeBillingTier?: BillingTier | null;
    pricePerArticle: number;
    imagesPerArticleLimit: number;
    linkedTeamsLimit: number;
    scrapeLimit: number;
    subscriptionPrice: number;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    currentMonthStart: string;
    currentMonthEnd: string;
  };
  usageForCurrentPeriod: {
    articles: number;
  };
  keywordQueryUsageForCurrentPeriod: {
    keywordQueries: number;
  };
  tenant?: {
    id: string;
    identityId: string;
    createdAt: string;
    name: string;
    memberCount: number;
    isOnboardingComplete: boolean;
    parentTenant?: {
      id: string;
      identityId: string;
      name: string;
    } | null;
    linkedTenants?:
      | {
          id: string;
        }[]
      | null;
  };
  articlesRemaining: number;
  keywordQueryCreditsRemaining: number;
  signOut: () => Promise<void> | void;
  selectOrganization: (id: string) => Promise<void>;
  userOrganizations?: {
    id: string;
  }[];
}

const UserContext = createContext<UserContextType>(defaultUserContext);

export default UserContext;
